import React from 'react';
import Relay from 'react-relay';
import { style, media, focus, keyframes } from 'glamor';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

import qs from 'qs';

import { trackProductSearch } from 'depop/utils/tracking';
import detectUserMention from 'depop/utils/detectUserMention';

const expandout = keyframes({
  from: { width: '0' },
  to: { width: '100%' },
});

const messages = defineMessages({
  queryPlaceholder: {
    id: 'GlobalSearch.queryPlaceholder',
    defaultMessage: 'Search for items',
    description: 'Search input placeholder when user has\'nt entered a query',
  },
});

class GlobalSearch extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static propTypes = {
    toggleSearch: React.PropTypes.func.isRequired,
    onSearch: React.PropTypes.func.isRequired,
    searchExpanded: React.PropTypes.bool.isRequired,
    intl: React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object,
  };

  setInputRef = el => {
    this._input = el;
  };

  handleSubmit = event => {
    event.preventDefault();

    trackProductSearch({
      query: this._input.value,
    });

    const presentUsername = detectUserMention(this._input.value);

    if (presentUsername) {
      this.context.router.push({
        pathname: `/${presentUsername}`,
      });

      this.props.onSearch();
    } else {
      this.context.router.push({
        pathname: '/search/',
        search: `?${qs.stringify({
          q: this._input.value,
        })}`,
      });

      this.props.onSearch();
    }
  };

  render() {
    const { toggleSearch, intl } = this.props;
    document.body.style.overflowY = 'scroll';

    return (
      <div {...style({
        margin: '-5px 0 0',
        position: 'relative',
        flexGrow: '1',
        width: '100%',
        background: 'white',
        transform: 'translateY(3px)',
      })}
        {...media('(max-width: 700px)', {margin: '-2px 0 3px'})}>
        <form
          action="/search/"
          method="get"
          onBlur={toggleSearch}
          onSubmit={this.handleSubmit}
          {...style({
            display: 'flex',
            alignContent: 'baseline',
            justifyContent: 'flex-end',
          })}>
          <input
            name="q"
            autoComplete="off"
            ref={this.setInputRef}
            autoFocus="true"
            type="text"
            placeholder={intl.formatMessage(messages.queryPlaceholder)}
            {...style({
              padding: '3px 0',
              appearance: 'none',
              border: 'none',
              marginRight: '.5em',
              fontSize: '16px',
              fontWeight: 'bold',
              borderBottom: '1px solid black',
              borderRadius: '0',
            })}
            {...focus({
              width: '100%',
              outline: 'none',
              fontWeight: 'normal',
              animationName: expandout,
              animationDuration: '.2s',
              animationFillMode: 'forwards',
            })} />
          <a
            {...style({
              appearance: 'none',
              border: '0',
              margin: '0',
              padding: '0',
              display: 'flex',
              alignItems: 'center',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              background: 'none',
            })}
            onClick={toggleSearch}>
            <FormattedMessage
              id="app.closeGlobalSearch"
              description="Closes the global search"
              defaultMessage="Close" />
          </a>
        </form>
        <div
          onClick={toggleSearch}
          {...style({
            position: 'fixed',
            top: '65px',
            left: '0',
            right: '0',
            bottom: '0',
            width: '100vw',
            height: '100vh',
          })}
        />
      </div>
    );
  }
}

export default Relay.createContainer(injectIntl(GlobalSearch), {
  fragments: {
    currentUser: () => Relay.QL`
      fragment on User {
        id
        publicId
        username
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/root/containers/components/GlobalSearch.js